import * as t from './actionTypes';
import { FETCH_ERRORS as e } from './constants';

export const initialState = {
  loading: false,
  error: {},
  reportDataAsCsv: '',
  csvExportInProgress: false,
  pdfReportLoading: false,
  pdfReportUrl: '',
  sortedCampaignIds: [],
  sortedCampaignIdsLoading: false,
  appliedCrossMetrics: [],
  appliedMediums: [],
  updateViewLoading: false,
  savedViews: [],
  recentSavedViews: [],
  savedViewLoaded: false,
  savedViewsPaginationOpts: {},
  filtersLoaded: false,
  campaignsFilter: {},
  aggStatsFilter: {},
  timeSeriesData: {
    loading: false,
    filter: '',
    data: {},
  },
  locationData: {
    loading: false,
    filter: '',
    data: {},
  },
  deviceData: {
    loading: false,
    filter: '',
    data: {},
  },
};

const messagingInsightsReducer = (state = initialState, action) => {
  switch (action.type) {
    case t.FETCH_CAMPAIGNS_REQUEST:
      return {
        ...state,
        campaignsLoading: true,
        campaignsFilter: action.queryData,
        error: {},
      };
    case t.FETCH_CAMPAIGNS_RESPONSE: {
      return {
        ...state,
        campaigns: action.response,
        campaignsLoading: false,
      };
    }
    case t.FETCH_CAMPAIGNS_ERROR: {
      return {
        ...state,
        campaignsLoading: false,
        error: { ...state.error, [e.FETCH_CAMPAIGNS]: action.error },
      };
    }
    case t.FETCH_X_MED_AGG_STATS_FOR_TIME_RANGE_REQUEST: {
      return {
        ...state,
        aggStatsLoading: true,
        aggStatsFilter: action.queryData,
        error: {},
      };
    }
    case t.FETCH_X_MED_AGG_STATS_FOR_TIME_RANGE_RESPONSE: {
      return {
        ...state,
        overallPerformanceData: action.overallPerformanceData,
        aggStatsLoading: false,
      };
    }
    case t.FETCH_X_MED_AGG_STATS_FOR_TIME_RANGE_ERROR: {
      return {
        ...state,
        aggStatsLoading: false,
        overallPerformanceData: {},
        error: { ...state.error, [e.FETCH_X_MED_AGG_STATS]: action.error },
      };
    }
    case t.FETCH_TIME_SERIES_DATA_FOR_TIME_RANGE_REQUEST: {
      return {
        ...state,
        timeSeriesData: {
          ...state.timeSeriesData,
          loading: true,
          filter: action.queryData,
        },
      };
    }
    case t.FETCH_TIME_SERIES_DATA_FOR_TIME_RANGE_RESPONSE: {
      return {
        ...state,
        timeSeriesData: {
          ...state.timeSeriesData,
          loading: false,
          data: action.payload,
        },
      };
    }
    case t.FETCH_TIME_SERIES_DATA_FOR_TIME_RANGE_ERROR: {
      return {
        ...state,
        error: { ...state.error, [e.FETCH_TIME_SERIES_DATA]: action.error },
        timeSeriesData: {
          ...state.timeSeriesData,
          loading: false,
        },
      };
    }
    case t.FETCH_LOCATION_DATA_FOR_TIME_RANGE_REQUEST: {
      return {
        ...state,
        locationData: {
          ...state.locationData,
          loading: true,
          filter: action.payload,
        },
      };
    }
    case t.FETCH_LOCATION_DATA_FOR_TIME_RANGE_RESPONSE: {
      return {
        ...state,
        locationData: {
          ...state.locationData,
          loading: false,
          data: action.payload,
        },
      };
    }
    case t.FETCH_LOCATION_DATA_FOR_TIME_RANGE_ERROR: {
      return {
        ...state,
        error: { ...state.error, [e.FETCH_LOCATION_DATA]: action.error },
        locationData: {
          ...state.locationData,
          loading: false,
        },
      };
    }
    case t.FETCH_DEVICE_DATA_FOR_TIME_RANGE_REQUEST: {
      return {
        ...state,
        deviceData: {
          ...state.deviceData,
          loading: true,
          filter: action.payload,
        },
      };
    }
    case t.FETCH_DEVICE_DATA_FOR_TIME_RANGE_RESPONSE: {
      return {
        ...state,
        deviceData: {
          ...state.deviceData,
          loading: false,
          data: action.payload,
        },
      };
    }
    case t.FETCH_DEVICE_DATA_FOR_TIME_RANGE_ERROR: {
      return {
        ...state,
        error: { ...state.error, [e.FETCH_DEVICE_DATA]: action.error },
        deviceData: {
          ...state.deviceData,
          loading: false,
        },
      };
    }
    case t.EXPORT_INSIGHT_REPORT_DATA_AS_CSV_REQUEST: {
      return {
        ...state,
        error: {},
      };
    }
    case t.EXPORT_INSIGHT_REPORT_DATA_AS_CSV_RESPONSE: {
      return {
        ...state,
        reportDataAsCsv: action.csvData,
      };
    }
    case t.EXPORT_INSIGHT_REPORT_DATA_AS_CSV_ERROR: {
      return {
        ...state,
        error: { ...state.error, [e.FETCH_INSIGHTS_REPORT_AS_CSV]: action.error },
      };
    }
    case t.FETCH_SEGMENTS_REQUEST: {
      return {
        ...state,
        segmentsLoading: true,
        error: {},
      };
    }
    case t.FETCH_SEGMENTS_RESPONSE: {
      return {
        ...state,
        segmentData: action.segmentData,
        segmentsLoading: false,
      };
    }
    case t.FETCH_SEGMENTS_ERROR: {
      return {
        ...state,
        error: { ...state.error, [e.FETCH_SEGMENTS]: action.error },
        segmentsLoading: false,
      };
    }
    case t.FETCH_SEGMENTSV2_REQUEST: {
      return {
        ...state,
        segmentsLoading: true,
        error: {},
      };
    }
    case t.FETCH_SEGMENTSV2_RESPONSE: {
      return {
        ...state,
        segmentData: action.segmentData,
        segmentsLoading: false,
      };
    }
    case t.FETCH_SEGMENTSV2_ERROR: {
      return {
        ...state,
        error: { ...state.error, [e.FETCH_SEGMENTSV2]: action.error },
        segmentsLoading: false,
      };
    }
    case t.GET_INSIGHTS_FILTERS_REQUEST: {
      return {
        ...state,
        filtersLoading: true,
        filtersLoaded: false,
        error: {},
      };
    }
    case t.GET_INSIGHTS_FILTERS_RESPONSE: {
      return {
        ...state,
        filters: action.response,
        filtersLoading: false,
        filtersLoaded: true,
        filtersError: undefined,
      };
    }
    case t.GET_PREVIEW_THUMBNAILS_RESPONSE: {
      return {
        ...state,
        previewThumbnails: action.response,
      };
    }
    case t.UPDATE_APPLIED_CROSS_METRICS: {
      return {
        ...state,
        appliedCrossMetrics: action.crossMetrics,
      };
    }
    case t.UPDATE_APPLIED_MEDIUMS: {
      return {
        ...state,
        appliedMediums: action.appliedMediums,
      };
    }
    case t.GET_INSIGHTS_FILTERS_ERROR: {
      return {
        ...state,
        filtersError: action.error,
        filtersLoading: false,
        filtersLoaded: true,
      };
    }
    case t.EXPORT_DESTINATIONS_AS_CSV_REQUEST: {
      return {
        ...state,
        csvExportInProgress: true,
        error: {},
      };
    }
    case t.EXPORT_DESTINATIONS_AS_CSV_ERROR: {
      return {
        ...state,
        csvExportInProgress: false,
        error: { ...state.error, [e.EXPORT_DESTINATIONS_AS_CSV]: action.error },
      };
    }
    case t.EXPORT_DESTINATIONS_AS_CSV_RESPONSE: {
      return {
        ...state,
        csvExportInProgress: false,
      };
    }
    case t.EXPORT_CAMPAIGNS_AS_CSV_REQUEST: {
      return {
        ...state,
        csvExportInProgress: true,
        error: {},
      };
    }
    case t.EXPORT_CAMPAIGNS_AS_CSV_ERROR: {
      return {
        ...state,
        csvExportInProgress: false,
        error: { ...state.error, [e.EXPORT_CAMPAIGNS_AS_CSV]: action.error },
      };
    }
    case t.EXPORT_CAMPAIGNS_AS_CSV_RESPONSE: {
      return {
        ...state,
        csvExportInProgress: false,
      };
    }
    case t.FETCH_SORTED_CAMPAIGN_IDS_BY_MULTI_MEDIUM_METRIC_REQUEST: {
      return {
        ...state,
        sortedCampaignIdsLoading: true,
        sortedCampaignIds: [],
        error: {},
      };
    }
    case t.FETCH_SORTED_CAMPAIGN_IDS_BY_MULTI_MEDIUM_METRIC_ERROR: {
      return {
        ...state,
        sortedCampaignIdsLoading: false,
        error: { ...state.error, [e.FETCH_SORTED_CAMPAIGN_IDS]: action.error },
      };
    }
    case t.FETCH_SORTED_CAMPAIGN_IDS_BY_MULTI_MEDIUM_METRIC_RESPONSE: {
      return {
        ...state,
        sortedCampaignIds: action.response || [],
        sortedCampaignIdsLoading: false,
      };
    }
    case t.FETCH_ALL_METRICS_FOR_CAMPAIGNS_REQUEST:
      return {
        ...state,
        allMetricsForCampaignsLoading: true,
        error: {},
      };
    case t.FETCH_ALL_METRICS_FOR_CAMPAIGNS_RESPONSE: {
      return {
        ...state,
        allMetricsForCampaigns: action.response,
        allMetricsForCampaignsLoading: false,
      };
    }
    case t.FETCH_ALL_METRICS_FOR_CAMPAIGNS_ERROR: {
      return {
        ...state,
        allMetricsForCampaignsLoading: false,
        error: { ...state.error, [e.FETCH_ALL_METRICS_FOR_CAMPAIGNS]: action.error },
      };
    }
    case t.FETCH_SAVED_VIEW_REQUEST:
      return {
        ...state,
        savedViewLoading: true,
        savedViewLoaded: false,
        error: {},
      };
    case t.FETCH_SAVED_VIEW_RESPONSE: {
      return {
        ...state,
        savedView: action.response,
        savedViewLoading: false,
        savedViewLoaded: true,
      };
    }
    case t.FETCH_SAVED_VIEW_ERROR: {
      return {
        ...state,
        savedViewLoading: false,
        savedViewLoaded: true,
        error: { ...state.error, [e.FETCH_SAVED_VIEW]: action.error },
      };
    }
    case t.CREATE_VIEW_REQUEST: {
      return {
        ...state,
        createViewLoading: true,
        error: {},
      };
    }
    case t.CREATE_VIEW_RESPONSE: {
      return {
        ...state,
        createViewLoading: false,
        savedView: action.view,
      };
    }
    case t.CREATE_VIEW_ERROR: {
      return {
        ...state,
        createViewLoading: false,
      };
    }
    case t.UPDATE_VIEW_REQUEST: {
      return {
        ...state,
        updateViewLoading: true,
        error: {},
      };
    }
    case t.UPDATE_VIEW_RESPONSE: {
      return {
        ...state,
        savedView: { ...state.savedView, ...action.view },
        updateViewLoading: false,
      };
    }
    case t.UPDATE_VIEW_ERROR: {
      return {
        ...state,
        updateViewLoading: false,
      };
    }
    case t.FETCH_SAVED_VIEWS_INFINITE_SCROLL_REQUEST:
      return {
        ...state,
        savedViewsLoading: true,
      };
    case t.FETCH_SAVED_VIEWS_INFINITE_SCROLL_RESPONSE: {
      return {
        ...state,
        savedViews:
          action?.response?.metadata?.page === 1
            ? action.response.records
            : [...state.savedViews, ...action.response.records],
        savedViewsPaginationOpts: action.response.metadata,
        savedViewsLoading: false,
      };
    }
    case t.FETCH_SAVED_VIEWS_INFINITE_SCROLL_ERROR: {
      return {
        ...state,
        savedViewsLoading: false,
      };
    }
    case t.FETCH_RECENT_SAVED_VIEWS_REQUEST:
      return {
        ...state,
        recentSavedViewsLoading: true,
        error: {},
      };
    case t.FETCH_RECENT_SAVED_VIEWS_RESPONSE: {
      return {
        ...state,
        recentSavedViews: action.response.records,
        recentSavedViewsLoading: false,
      };
    }
    case t.FETCH_RECENT_SAVED_VIEWS_ERROR: {
      return {
        ...state,
        recentSavedViewsLoading: false,
      };
    }
    case t.FETCH_PROJECT_DEFAULT_VIEW_REQUEST:
      return {
        ...state,
        projectDefaultViewLoading: true,
        error: {},
      };
    case t.FETCH_PROJECT_DEFAULT_VIEW_RESPONSE: {
      return {
        ...state,
        projectDefaultView: action.response,
        projectDefaultViewLoading: false,
      };
    }
    case t.FETCH_PROJECT_DEFAULT_VIEW_ERROR: {
      return {
        ...state,
        projectDefaultViewLoading: false,
      };
    }
    case t.FETCH_PDF_REPORT_REQUEST: {
      return {
        ...state,
        pdfReportLoading: true,
        error: {},
      };
    }
    case t.FETCH_PDF_REPORT_RESPONSE: {
      return {
        ...state,
        pdfReportLoading: false,
        pdfReportUrl: action.response,
      };
    }
    case t.FETCH_PDF_REPORT_ERROR: {
      return {
        ...state,
        pdfReportLoading: false,
        error: { ...state.error, [e.FETCH_PDF_REPORT]: action.error },
      };
    }
    case t.RESET_PDF_REPORT: {
      return {
        ...state,
        error: {},
        pdfReportLoading: false,
        pdfReportUrl: '',
      };
    }
    default:
      return state;
  }
};

export default messagingInsightsReducer;
